import React, { useEffect, useState, useCallback, useRef } from 'react'
import type { RadioChangeEvent } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import Collapse,{Panel} from '@ui/Collapse'
import { Button, Card, Row, Col, Form, Radio, Select, Input, Checkbox } from 'antd'
import SearchIcon from '@material-ui/icons/Search';
import SearchDebounceBar from "../SearchDebounce"
import ImputComponent from "../InputComponent";
import { getChains, getUserChains, updateUserChains } from '../UserManagement/helper'
import ActionButtonsBar from '@ui/ActionButtonsBar'; 
import PageContainer from '@CSIComponents/PageContainer';
import Loading from '@components/Loading';
import { isSuperAdminUser } from '@helpers/users/index'
import { LocalPersistence } from '../../factories/index'


type propsTypes = {
  record : {
    id: number
    role: string
    name: string
    username: string
    email: string
    userroles: string
    status: string,
    company: string
  }
  setIsOnEdit: (status: boolean) => void
}

const UserListEdit = (props: propsTypes) => {
  const Option = Select.Option
  const [dataSource, setDataSource] = useState<any>([])
  const [cloneData, setCloneData] = useState<any>([])
  const [cloneValues, setCloneValues] = useState<any>([])
  const [value, setValue] = useState<any>([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(true)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(true)

  const onChange = (e: RadioChangeEvent, index: number, name: string) => {
    const valuesData = value
    const updatedValue = value[index] = e.target.value
    const [{id}] = cloneData[0].chains.filter(({ name: chainName } : { name: string }) => name === chainName)
    valuesData[id - 1] = e.target.value
    setValue({ ...value, ...updatedValue });
    setCloneValues({ ...value, ...updatedValue });
    isSaveDisabled && setIsSaveDisabled(false)
  };

  const onChangeCheckBox = (e: CheckboxChangeEvent, index: number) => {
    dataSource[0].chains[index].checked = !dataSource[0].chains[index].checked
    value[index] = 1
    const resetRadioValues = {
      ...value
    }
    setDataSource({ ...dataSource })
    setCloneData({ ...dataSource })
    setValue({ ...resetRadioValues })
    setCloneValues({ ...resetRadioValues })
    isSaveDisabled && setIsSaveDisabled(false)
  };

  const onClearAll = () => {
    const clearValues: number[] = []
    const clearData = dataSource[0].chains.map((item: { checked: boolean }) => {
      item.checked = false;
      clearValues.push(1)
      return item
    })
    const data = dataSource
    data[0].chains = clearData;
    setDataSource({ ...data });
    setValue(clearValues);
    isSaveDisabled && setIsSaveDisabled(false)
  }

  const onSelectAll = () => {
    const clearData = dataSource[0].chains.map((item: { checked: boolean }) => {
      item.checked = true;
      return item
    })
    const data = dataSource
    data[0].chains = clearData;
    setDataSource({ ...data });
    isSaveDisabled && setIsSaveDisabled(false)
  }

  const selectAllLikeView = () => {
    const values: number[] = []
    dataSource[0].chains.map((item: any, index: number) => {
      if (item.checked) {
        return values.push(1)
      }
      return values.push(value[index])
    })
    setValue(values)
    setCloneValues(values)
    isSaveDisabled && setIsSaveDisabled(false)
  }

  const selectAllLikeViewAndEdit = () => {
    const values: number[] = []
    dataSource[0].chains.map((item: any, index: number) => {
      if (item.checked) {
        return values.push(2)
      }
      return values.push(value[index])
    })
    setValue(values)
    setCloneValues(values)
    isSaveDisabled && setIsSaveDisabled(false)
  }

  const selectAllLikeViewEditAndHotel = () => {
    const values: number[] = []
    dataSource[0].chains.map((item: any, index: number) => {
      if (item.checked) {
        return values.push(3)
      }
      return values.push(value[index])
    })
    setValue(values)
    setCloneValues(values)
    isSaveDisabled && setIsSaveDisabled(false)
  }

  const init = useCallback(async() => {
    const radioValues : number[] = []
    const { chains }: any = await getChains()
    const { user }: any = await getUserChains({ id: props.record.id }) 
    const selectedChains = user.chains.map(({ chainName } : { chainName: string, privilege: number }) => chainName);
    const privilegeHash = {}
    user.chains.map(({ chainName, privilege } : { chainName: string, privilege: number }) => privilegeHash[chainName] = privilege); 
    chains.map((chain : { name: string, checked: boolean, privilege: number, display: boolean }) => {
      chain.display = true
      if (selectedChains.includes(chain.name)) {
        radioValues.push(privilegeHash[chain.name])
        return chain.checked = true
      } else {
        radioValues.push(1)
        return chain.checked = false
      }
    });

    const updatedData = [{
      ...user,
      chains
    }]

    setIsSuperAdmin(await isSuperAdminUser())
    setDataSource(updatedData);
    setCloneData(updatedData);
    setValue(radioValues)
    setCloneValues(radioValues)
    setIsLoading(false)
  }, [])

  useEffect(() => {
    init()
  }, [init])


  const filterData = async (query: string) => {
    const dataToBeFiltered = JSON.parse(JSON.stringify(cloneData))
    dataToBeFiltered[0].chains.map((chain : { name: string, display: boolean }) => {
      if (chain.name.toLocaleLowerCase().includes(query)) {
        return chain.display = true
      }
      return chain.display = false
    })
    setDataSource(dataToBeFiltered)
}

  const onChangeSearch = (term: string) => {
    setSearchTerm(term)
    onDebounce(term)
  }

  const {
    searchTerm, setSearchTerm, searchTermDebounced, onDebounce
  } = SearchDebounceBar()

  const afterDebounce = (term: string) => {
    filterData(term)
}

const initialRender = useRef(true);

  // search functionality
  useEffect(() => {
    if (initialRender.current) {
        initialRender.current = false;
    } else {
        afterDebounce(searchTermDebounced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
}, [searchTermDebounced])

const updateUser = async () => {
  setIsLoading(true)
  dataSource[0].chains.map((_: any, index: number) => {
    dataSource[0].chains[index].privilege = cloneValues[index]
    return dataSource[0].chains[index].chainName = dataSource[0].chains[index].name
  })
  const filteredChains = dataSource[0].chains.filter(({ checked } : { checked: boolean }) => checked )

  const role = form.getFieldValue('userroles'); 
  const body = {
    userId: props.record.id,
    role: role,
    userName: props.record.name,
    company : props.record.company,
    chains: filteredChains
  }

  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence() 

  const isCurrentUser = userToUpdateIsCurrentUser(body.userName, session.givenName)

  if(isCurrentUser){
    const roles = new LocalPersistence("session", {
      ...session,
      role
    });
    await roles.setSessionPersistence() 
    
  }
  
  updateUserChains({ id: props.record.id,  body })
  return setTimeout(() => {
    setIsLoading(false);
    props.setIsOnEdit(false);
  }, 700)
}

const userToUpdateIsCurrentUser =  (userName: string, givenName: string): boolean =>  {
  return givenName?.toLowerCase() === userName?.toLowerCase();
}    

const renderContainer = ({ name, index, checked, display } : { name: string, index: number, checked: boolean, display: boolean }) => {
  return (
    display && <Row gutter={24}>
      <Col span={6} style={{ padding: 20 }}>
        <Checkbox key={`checkbox-${index}`} checked={checked} onChange={(e: any) => onChangeCheckBox(e, index)}>
          {name}
        </Checkbox>
      </Col>
        {checked && <Radio.Group 
          onChange={(e) => onChange(e, index, name)} 
          value={cloneValues[index]}
          key={`radio-${index}`} 
          style={{
            padding: '20px 10px',
            display: 'flex',
            justifyContent: 'space-between' 
          }}
        >
            <Radio value={1} style={{ marginRight: 80, marginLeft: -10}}>View Only</Radio>
            <Radio value={2} style={{ marginRight: 70 }}>View & Edit</Radio>
            <Radio value={3}>View, Edit, Add Hotel</Radio>
        </Radio.Group>}
    </Row>
  )
}

  const [form] = Form.useForm();

  return(
    <>
      <PageContainer>
      <Card style={{ height: '95%'}}>
        <Collapse defaultActiveKey={['1']} onChange={() => console.log('')}>
          <Panel header="User Info" key="1">
            <Form
              layout="vertical"
              name="basic"
              initialValues={{
                username: props.record.name,
                email: props.record.email,
                userroles: props.record.role,
                status: props.record.status,
                company: props.record.company
              }}
              form={form}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                      label="User Name"
                      name="username"
                      rules={[{ required: true, message: 'This field is required' }]}
                  >
                      <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: 'This field is required' }]}
                  >
                      <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                      label="Company"
                      name="company"
                      rules={[{ required: true, message: 'This field is required' }]}
                  >
                      <Input disabled />
                  </Form.Item>
                </Col>
                {/* <Col span={6}>
                  <Form.Item
                      label="Status"
                      name="status"
                      rules={[{ required: true, message: 'This field is required' }]}
                  >
                      <Input disabled />
                  </Form.Item>
                </Col> */}
              </Row>
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                      label="User Role"
                      name="userroles"
                      rules={[{ required: true, message: 'This field is required' }]}
                  >
                    <Select allowClear showSearch disabled={isLoading}>
                      { 
                        isSuperAdmin && <Option value='Super Admin'>Super Admin</Option>
                      }
                      <Option value='Account Admin'>Account Admin</Option>
                      <Option value='Internal User'>Internal User</Option>
                      <Option value='User'>User</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {!isLoading && dataSource[0] && dataSource[0].chains && 
                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item
                        label="Context Access & Privilege"
                        name="contextaccess"
                    >
                        <ImputComponent
                            className='SearchBar'
                            labelShrink={true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder="Search chains here..."
                            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                        />
                    </Form.Item>
                  </Col>
                </Row>
              }
            </Form>
            <Row gutter={24}>
              <Col span={6}>
                <Button onClick={onSelectAll}>Select All</Button>
                <Button onClick={onClearAll}>Clear All</Button>
              </Col>
                <Button onClick={selectAllLikeView} style={{ marginRight: 75 }}>Select All</Button>
                <Button onClick={selectAllLikeViewAndEdit} style={{ marginRight: 75 }}>Select All</Button>
                <Button onClick={selectAllLikeViewEditAndHotel}>Select All</Button>
            </Row>
            <>
              {
                !isLoading && dataSource[0] && dataSource[0].chains
                  .map(({ name, checked, display } : { name: string, checked: boolean, display: boolean }, index: number) => 
                    renderContainer({ name, index, checked, display }))
              }
            </>
          </Panel>
        </Collapse>
      </Card>
      { !isLoading && dataSource[0] && dataSource[0].chains &&
        <div className="relative-parent">
          <ActionButtonsBar
              onDelete={false}
              onCancel={() => props.setIsOnEdit(false)}
              onSave={updateUser}
              disabledSave={isSaveDisabled}
              warningMsg={false}
          />
        </div>
      }
      { 
        isLoading && (
          <Loading  type='large' />
        )
      }
      </PageContainer>
    </>
  )
}

export default UserListEdit
